export const yellow = "Ekb";
export const green = "Fkb";
export const pink = "Gkb";
export const purple = "Hkb";
export const blue = "Ikb";
export const gray = "Jkb";
export const charcoal = "Kkb";
export const white = "Lkb";
export default {yellow,green,pink,purple,blue,gray,charcoal,white};